<div class="container card p-4 mt-2">
    <h4>{{ templateName }}</h4>
    <div *ngIf="fieldNames.length >0 ">
        <div class="card-header d-flex align-items-center ml-3 mr-3">
            <div class="w-50 text-start">Change legacy variables</div>
            <div class="w-50 text-start">To new variables</div>
            <div class="w-50 text-start">Value</div>
        </div>
        <div class="card-body">
            <form [formGroup]="form">
                <div formArrayName="fieldNames">
                    <div *ngFor="let ctrl of controls(); let i = index">
                        <ng-container [ngSwitch]="ctrl.value">
                            <div *ngSwitchCase="'CREATED_DATE_'">
                            </div>
                            <div *ngSwitchCase="'MODIFIED_DATE_'">
                            </div>
                            <div *ngSwitchCase="'ID_CUSTOM'">
                            </div>
                            <div *ngSwitchCase="'IDCUSTOM'">
                            </div>
                            <div *ngSwitchCase="'LANGUAGE'">
                            </div>
                            <div *ngSwitchCase="'SUBJECT'">
                            </div>
                            <div *ngSwitchCase="'PREHEADER'">
                            </div>
                            <div *ngSwitchCase="'SUBJECT_1'">
                            </div>
                            <div *ngSwitchCase="'PREHEADER_1'">
                            </div>
                            <div *ngSwitchDefault>
                                <div class="mb-2 align-items-center row">
                                    <div class="col-3">
                                        <input class="form-control" [formControlName]="i"
                                               [class.is-valid]="ctrl.valid"
                                               [class.is-invalid]="ctrl.invalid"
                                        />
                                        <!-- if / else -->
                                        <div class="d-flex">
                                            <!--                                            <div *ngIf="ctrl.hasError('notInOptions'); else validTpl"-->
                                            <!--                                                 class="invalid-feedback small">-->
                                            <!--                                                <span>Variable is invalid.</span>-->
                                            <!--                                            </div>-->

                                            <!--                                            <ng-template #validTpl>-->
                                            <!--                                                <div class="valid-feedback small" *ngIf="ctrl.valid">-->
                                            <!--                                                    Variable is valid.-->
                                            <!--                                                </div>-->
                                            <!--                                            </ng-template>-->
                                            <span class="small text-muted">Old value: {{ oldFieldNames[i] }}</span>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <select class="form-select ml-2 mb-4" [formControlName]="i"
                                                (change)="onSelect(i, $any($event.target).value,oldFieldNames[i])">
                                            <option value="">Choose variable</option>
                                            <ng-container *ngFor="let grp of variableOptions">
                                                <optgroup [label]="grp.label">
                                                    <option *ngFor="let opt of grp.options" [value]="opt.value">
                                                        {{ opt.label }}
                                                    </option>
                                                </optgroup>
                                            </ng-container>
                                        </select>
                                    </div>

                                    <div class="disabled col align-items-center"> {{ records[0][i] }}</div>


                                    <!--                                    <ng-select class="w-50 ml-2 mb-4"-->
                                    <!--                                               [items]="flatOptions"-->
                                    <!--                                               bindLabel="label"-->
                                    <!--                                               bindValue="value"-->
                                    <!--                                               [groupBy]="'group'"-->
                                    <!--                                               [searchable]="true"-->
                                    <!--                                               [clearable]="true"-->
                                    <!--                                               [formControlName]="i"-->
                                    <!--                                               (change)="onSelect(i, $event, oldFieldNames[i])"-->
                                    <!--                                               placeholder="Choose variable">-->
                                    <!--                                    </ng-select>-->
                                </div>

                            </div>

                        </ng-container>
                    </div>
                </div>
                <button type="submit" pButton class="btn btn-primary" (click)="saveKeys()">Save variables</button>
            </form>

        </div>
    </div>
</div>
